import { Box, Button, Typography } from "@material-ui/core"
import { DialogSaurus } from "../dialog-saurus/dialog-saurus"
import { OkIcon } from "../../icons/ok-icon"
import { DeliveryIcon } from "../../icons/delivery-icon"
import { CanceladoIcon } from "../../icons"
import { useDialog } from "../../../../services/app/providers/dialog-provider"
import { useToastSaurus } from "../../../../services/app"
import { useState } from "react"
import { CircularLoading } from "../../utils"

export interface DialogAssumirEntregaProps {
    onClickAssumir: (alterarStatusEntrega?: boolean) => Promise<void>
    aberto: boolean
}

export const DialogAssumirEntrega = ({ onClickAssumir, aberto }: DialogAssumirEntregaProps) => {

    const { fecharAssumirEntrega } = useDialog()
    const [carregandoInterno, setCarregandoInterno] = useState(false)
    const { showToast } = useToastSaurus()

    const handleAssumirEntrega = async (alterarStatusEntrega?: boolean) => {
        try {
            setCarregandoInterno(true)
            await onClickAssumir(alterarStatusEntrega)
            fecharAssumirEntrega()
        } catch (error: any) {
            showToast('error', `Erro ao assumir pedido. Detalhe: ${error?.message}`)
        }
        finally {
            setCarregandoInterno(false)
        }
    }
    return (
        <DialogSaurus
            titulo="Assumir Entrega"
            aberto={aberto}
        >
            {carregandoInterno && <CircularLoading tipo="FULLSIZED" />}
            <Box gridGap={16} display="flex" flexDirection={"column"}>
                <Typography>
                    Selecione uma das opções abaixo para assumir a entrega do pedido.
                </Typography>
                <Button variant="contained" color="primary" fullWidth onClick={() => handleAssumirEntrega(false)}>
                    <OkIcon tipo="BUTTON_PRIMARY" />
                    Assumir pedido
                </Button>
                <Box display="flex" flexDirection={"column"}>
                    <Button variant="contained" color="primary" fullWidth onClick={() => handleAssumirEntrega(true)}>
                        <DeliveryIcon tipo="BUTTON_PRIMARY" />
                        Iniciar entrega agora
                    </Button>
                    <Typography variant="caption" align="center">
                        Essa opção irá alterar o status do pedido para "Em entrega"
                    </Typography>
                </Box>
                <Button variant="outlined" color="primary" fullWidth onClick={() => fecharAssumirEntrega()} style={{
                    marginTop: 16,
                }}>
                    <CanceladoIcon tipo="BUTTON" />
                    Cancelar
                </Button>
            </Box>
        </DialogSaurus>
    )
}